<div class="landing-page">
    <!-- tap on top starts-->
    <div class="tap-top"><i data-feather="chevrons-up"></i></div>
    <!-- tap on tap ends-->
    <!-- page-wrapper Start-->
    <div class="page-wrapper landing-page">
        <!-- Page Body Start            -->
        <div class="landing-homes">

            <div class="container-fluid">
                <div class="sticky-header">
                    <header>
                        <nav class="navbar navbar-b navbar-trans navbar-expand-xl fixed-top nav-padding"
                            id="sidebar-menu">
                            <a class="navbar-brand p-0" href="#"><img class="img-fluid"
                                    src="{{layout.getLogo()}}" alt=""></a>
                            <button class="navbar-toggler navabr_btn-set custom_nav" type="button"
                                data-bs-toggle="collapse" data-bs-target="#navbarDefault" aria-controls="navbarDefault"
                                aria-expanded="false"
                                aria-label="Toggle navigation"><span></span><span></span><span></span></button>
                            <div class="navbar-collapse justify-content-end collapse hidenav" id="navbarDefault">
                                <ul class="navbar-nav navbar_nav_modify" id="scroll-spy">
                                    <li class="nav-item"><a class="nav-link text-black"
                                            href="landing/home#product">Produk</a></li>
                                    <li class="nav-item"><a class="nav-link"
                                            href="landing/documentation-api">Dokumentasi</a></li>
                                    <li class="nav-item"><a class="nav-link" href="landing/home#faq">FAQ</a></li>
                                    <li class="nav-item"><a class="nav-link" href="landing/about">Tentang Kami</a></li>
                                    <li class="nav-item"><a class="nav-link" href="landing/home#contact">Kontak</a></li>
                                    <li class="btn btn-sm btn-primary nav-item buy-btn"><a (click)="open(login)"
                                            class="nav-link js-scroll" style="color:#fff;">Login</a></li>
                                </ul>
                            </div>
                        </nav>
                    </header>
                </div>

            </div>
        </div>

        <section class="section-space cuba-demo-section bg-Widget p-b-150 bg-primary" id="about">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 wow pulse">
                        <div class="cuba-demo-content p-b-100 m-t-50 m-b-150">
                            <div class="couting">
                                <h1>Dokumentasi API</h1>
                            </div>
                            <p *ngIf="layout.getTenant()!='Bankaltimtara'" style="padding:100px;">Developer Console is a dashboard for developers to manage their
                                App including Credential management, Transaction Management, and other features. You can
                                access the developer console using this link https://developer.bankkalbar.com/console.
                            </p>
                            <p *ngIf="layout.getTenant() =='Bankaltimtara'" style="padding:100px;">Developer Console is a dashboard for developers to manage their
                                App including Credential management, Transaction Management, and other features. You can
                                access the developer console using this link https://developer.bankkaltim.com/console.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-space cuba-demo-section" id="product">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 wow pulse">
                        <div class="cuba-demo-content mt50">
                            <div class="couting">
                                <h2 align="left">Getting Started</h2>
                            </div>
                            <div align="left">
                                <p>Before using developer console features, you need to create account and
                                    register your account as a developer account. We recommend using corporate email
                                    than personal email when you register because this email
                                    will be used as a super admin role, updates regarding API, and Jira Service Desk
                                    login. On the other hand to use developer console features you need to prepare your
                                    Business Registration Certificate as a PDF file.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" align="left">
                    <!-- Menu Kiri -->
                    <div class="col-xl-3 col-sm-12 col-3">
                        <div class="default-according style-1 faq-accordion job-accordion">
                            <div class="accordion" id="accordionExample">
                                <ngb-accordion #acc="ngbAccordion" class="accordion">
                                    <ngb-panel>
                                        <ng-template ngbPanelTitle>
                                            <span class="d-block" for="chk-ani1">
                                                <a>Get Started</a>
                                            </span>
                                        </ng-template>
                                        <ng-template ngbPanelContent>
                                            <label class="d-block" for="chk-ani">
                                                Introduction
                                            </label>
                                        </ng-template>
                                    </ngb-panel>
                                </ngb-accordion>
                            </div>
                        </div>

                        <div class="default-according style-1 faq-accordion job-accordion">
                            <div class="accordion" id="accordionExample">
                                <ngb-accordion #acc="ngbAccordion" class="accordion">
                                    <ngb-panel>
                                        <ng-template ngbPanelTitle>
                                            <span class="d-block" for="chk-ani1">
                                                <a>Security</a>
                                            </span>
                                        </ng-template>
                                        <ng-template ngbPanelContent>
                                            <label class="d-block" for="chk-ani">
                                                Create SNAP Key
                                            </label>
                                            <label class="d-block" for="chk-ani">
                                                Signature (SNAP)
                                            </label>
                                        </ng-template>
                                    </ngb-panel>
                                </ngb-accordion>
                            </div>
                        </div>
                    </div>
                    <!-- End Menu Kiri -->
                    <!-- Menu Kanan -->
                    <div class="col-xl-9 col-sm-12 col-9">
                        <div class="card">
                            <div class="job-search">
                                <div class="card-body">
                                    <div class="media"><img class="img-40 p-0 img-fluid m-r-20"
                                            src="/assets/images/job-search/4.jpg" alt="">
                                        <div class="media-body">
                                            <h6 class="f-w-600"><a href="#">Introduction</a></h6>
                                            <p>{{layout.getUrlMitra()}}</p>
                                        </div>
                                    </div>
                                    <p>Overview of {{layout.getTenant()}} Sandbox APIs:</p>
                                </div>
                            </div>
                        </div>
                        <!-- end card 1 -->

                        <div class="card">
                            <div class="job-search">
                                <div class="card-body" >
                                    <div id="createSnap">
                                        <h6 class="f-w-800">Create Snap Key</h6>
                                        <p>1. Buka Portal Mitra melalui {{layout.getUrlMitra()}}</p>
                                        <p>2. Daftar terlebih dahulu jika belum memiliki akun</p>
                                        <p>3. Login ke dalam portal tersebut menggunakan akun yang sudah terdaftar</p>
                                        <p>4. Setelah berhasil Login, selanjutnya pilih menu "Aplikasi Saya" dan pilih "Add Apps"</p>
                                        <p>5. Input data terkait Aplikasi yang akan didaftarkan, pilih produk APIs dan pilih Submit.</p>
                                        <p>6. Kemudian Klik Detail untuk melihat Kredensial untuk Aplikasi Saya</p>
                                    </div>
                                    <hr><!--SIGNATURE SNAP-->
                                    <div id="signature">
                                        <h6 class="f-w-800">Signature (SNAP)</h6>
                                        <br/>
                                        <h6 class="f-w-400">Generate Signature Asymmetric</h6>
                                        <p>Signature Asymmetric digunakan oleh bank untuk memverifikasi bahwa permintaan token akses Anda tidak diubah oleh pihak yang tidak bertanggung jawab.
                                            SHA256withRSA digunakan untuk men-generate signature dengan private key anda sebagai key-nya. 
                                        </p>
                                        <table align="center" style="border-style: solid; border-width: 1px;">
                                            <tbody>
                                                <tr>
                                                    <td style="text-align: center;">X-SIGNATURE = SHA256withRSA(PrivateKey, StringToSign)</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p>Note = X-Signature harus diencoded menggunakan metode Base 64</p>
                                        <p>StringToSign akan berupa daftar yang dipisahkan titik dua yang berasal dari beberapa request data seperti di bawah ini:</p>
                                        <table align="center" style="border-style: solid; border-width: 1px;">
                                            <tbody>
                                                <tr>
                                                    <td style="text-align: center;">StringToSign = client_ID+"|"+X-TIMESTAMP</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p>Note = Mitra perlu mengirimkan public key dalam format x.509 untuk digunakan bank saat memverifikasi signature.
                                            Contoh public key dalam format x.509 :
                                        </p>
                                        <table align="center" style="border-style: solid; border-width: 1px;">
                                            <tbody>
                                                <tr>
                                                    <td style="text-align: center;">-----BEGIN PUBLIC KEY-----</td>
                                                </tr>
                                                <tr>
                                                    <td style="text-align: center;">MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAomV+Vm1xlRXanmh108Kusls7SSKec0oCejtc9QG Obpd4RnQ+7gihm2k6etnSNP7b+XrpY+fBkiQNaBInii9M10kW9Bhf/M9GH/edL3IqnzDNSi7tcoQgnO7h8x mzLNWHTjtR6bkrsdBS5dry6htotaF5KXomuoYgztCdGDOa0W20aeLzYSXIoW7s/Ay5yIXt0xaXTll3/bmez leguFPnwQZq5EqZFWlUZvutDi+f2l9rTRY0Fb64y+VAf+mnIbEovGqsPEeF/p97YWxcY7CWm8NsT0lwBVOt kmEl967Brz5yvEObF5bJgVodi6mNVsN1ki0MCitIhYO8shcE7eUilQIDAQAB</td>
                                                </tr>
                                                <tr>
                                                    <td style="text-align: center;">-----END PUBLIC KEY-----</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end card 2 -->
                <div class="row" align="left">
                    <!--API Services-->
                    <div class="col-xl-3 col-sm-12 col-3">
                        <div class="default-according style-1 faq-accordion job-accordion">
                            <div class="accordion" id="accordionExample">
                                <div class="card">
                                    <div class="card-header" id="headingOne">
                                        <h2 class="mb-0">
                                            <button class="btn btn-link btn-block text-start" type="button"
                                                data-bs-toggle="collapse">API Services</button>
                                        </h2>
                                    </div>
                                    <div *ngFor="let s of rows">
                                        <ngb-accordion #acc="ngbAccordion" *ngIf="s.paths && s.paths.length > 0" >
                                            <ngb-panel>
                                                    <ng-template ngbPanelTitle >
                                                        <label class="d-block" for="chk-ani1" style="white-space: pre-wrap;word-wrap: break-word;">
                                                            <a>{{s.name}} </a>
                                                        </label>
                                                    </ng-template>
                                                    <ng-template ngbPanelContent>
                                                        <button *ngFor="let p of s.paths" type="button" (click)="onClickData(p.id, p)"
                                                            class="apiServicesList">{{p.name}} (v{{p.pathVersioning[0].version}})
                                                        </button>
                                                    </ng-template>
                                            </ngb-panel>
                                        </ngb-accordion>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--API Services Detail-->
                    <div class="col-xl-9 col-sm-12 col-9">
                        <div *ngFor="let b of rowsData; let i = index">
                            <div class="card" id={{b.id}}>
                                <div class="job-search">
                                    <div class="card-body">
                                        <div class="media"><img class="img-40 p-0 img-fluid m-r-20"
                                                src="/assets/images/job-search/2.jpg" alt="">
                                            <div class="media-body">
                                                <h6 class="f-w-600"><a href="#">{{b.name}}</a></h6>
                                                <!-- <p>Latest Update : 2022-10-06</p> -->
                                            </div>
                                        </div>
                                        <br /><br />
                                        <h5>Deskripsi Produk</h5>
                                        <p class="m-b-50">{{desc}}</p>
                                        <h5>Informasi API</h5>
                                        <div class="field field--hidden text__field-text" [hidden]="b.pathService == 0">
                                            <table
                                                class="table table-responsive-sm table-bordered table-striped table-sm">
                                                <thead>
                                                    <th>Title</th>
                                                    <th>URL</th>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let c of b.pathService; index as i">
                                                        <td>{{ b.name }}</td>
                                                        <td>{{ c.fullPathRoute }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="alert alert-warning" [hidden]="b.pathService.length != 0">
                                            <strong>Warning!</strong> Data Masih Kosong
                                        </div>

                                        <h5>Kendali Versi</h5>
                                        <div class="field field--hidden text__field-text"
                                            [hidden]="b.pathVersioning.length == 0">
                                            <table
                                                class="table table-responsive-sm table-bordered table-striped table-sm">
                                                <thead>
                                                    <th>Version API</th>
                                                    <th>Tanggal</th>
                                                    <th>Deskripsi</th>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let d of b.pathVersioning; index as i">
                                                        <td>{{ d.version | number }}</td>
                                                        <td>{{ d.createdDate }}</td>
                                                        <td>{{ d.description }}</td>
                                                    </tr>
                                                    <td></td>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="alert alert-warning" [hidden]="b.pathVersioning.length != 0">
                                            <strong>Warning!</strong> Data Masih Kosong
                                        </div>

                                        <h5>Header Structure</h5>
                                        <div class="field field--hidden text__field-text"
                                            [hidden]="b.requestHeader.length == 0">
                                            <table
                                                class="table table-responsive-sm table-bordered table-striped table-sm">
                                                <thead>
                                                    <th>Key</th>
                                                    <th>Value</th>
                                                    <th>Format</th>
                                                    <th>Mandatory</th>
                                                    <th>Length</th>
                                                    <th>Deskripsi</th>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let e of b.requestHeader; index as i">
                                                        <td>{{ e.name }}</td>
                                                        <td>{{ e.value }}</td>
                                                        <td>{{ e.format }}</td>
                                                        <td>{{ e.mandatory==true?"M":"O" }}</td>
                                                        <td>{{ e.length }}</td>
                                                        <td>{{ e.description }}</td>
                                                    </tr>
                                                    <td></td>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="alert alert-warning" [hidden]="b.requestHeader.length != 0">
                                            <strong>Warning!</strong> Data Masih Kosong
                                        </div>

                                        <h5>Request Structure</h5>
                                        <div [hidden]="b.requestBody.length == 0">
                                            <table class="table table-responsive table-striped">
                                                <thead>
                                                    <th>Field</th>
                                                    <th>Data Type</th>
                                                    <th>Format</th>
                                                    <th>Mandatory</th>
                                                    <th>Length</th>
                                                    <th>Deskripsi</th>
                                                    <!-- <th>Contoh</th> -->
                                                    <!-- <th>Request Body Rule</th> -->
                                                    <!--ini gimana ngesetnya?-->
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let f of reqBodysDetail; index as i">
                                                        <td>
                                                            <ng-container *ngFor="let n of consLevel(f.level)">
                                                            <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                                                            </ng-container>
                                                            {{ f.name }}
                                                        </td>
                                                        <td>{{ f.dataType }}</td>
                                                        <td>{{ f.format }}</td>
                                                        <td>{{ f.mandatory==true?"M":"O" }}</td>
                                                        <td>{{ f.length }}</td>
                                                        <td>{{ f.description }}</td>
                                                        <!-- <td>{{ f.example }}</td> -->
                                                        <!-- <td>{{ f.requestBodyRule.string }}</td> -->
                                                    </tr>
                                                    <td></td>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="alert alert-warning" [hidden]="b.requestBody.length != 0">
                                            <strong>Warning!</strong> Data Masih Kosong
                                        </div>

                                        <h5>Response Structure</h5>
                                        <div [hidden]="b.responseBody.length == 0">
                                            <table class="table table-responsive table-striped">
                                                <thead>
                                                    <th>Field</th>
                                                    <th>Data Type</th>
                                                    <th>Format</th>
                                                    <th>Mandatory</th>
                                                    <th>Length</th>
                                                    <th>Deskripsi</th>
                                                    <th>Contoh</th>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let g of responseBodysDetail; index as i">
                                                        <td>
                                                            <ng-container *ngFor="let n of consLevel(g.level)">
                                                            <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                                                            </ng-container>
                                                            {{ g.name }}
                                                        </td>
                                                        <td>{{ g.dataType }}</td>
                                                        <td>{{ g.format }}</td>
                                                        <td>{{ g.mandatory==true?"M":"O" }}</td>
                                                        <td>{{ g.length }}</td>
                                                        <td>{{ g.description }}</td>
                                                        <td>{{ g.example }}</td>
                                                    </tr>
                                                    <td></td>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="alert alert-warning" [hidden]="b.responseBody.length != 0">
                                            <strong>Warning!</strong> Data Masih Kosong
                                        </div>

                                        <h5>Request & Response Payload Sample</h5>
                                        <h6>Request :</h6>
                                        <pre class="mb-0">
                                            <code id="notify-code-show" class="m-b-25">
                                            <div id="clipboardExampleReq">{{b.reqBodyJsonString}}</div>
                                            </code>
                                        </pre>
                                        <div class="mt-3 m-b-25 text-end">
                                            <button class="btn btn-primary btn-clipboard" type="button"
                                                data-clipboard-action="copy"
                                                (click)="copyTextToClipboard(b.reqBodyJsonString)"
                                                data-clipboard-target="#clipboardExampleReq"><i class="fa fa-copy"></i>
                                                Copy</button>
                                        </div>
                                        <h6>Response :</h6>
                                        <pre class="mb-0">
                                            <code id="notify-code-show" class="m-b-25">
                                            <div id="clipboardExampleRes">{{b.respBodyJsonString}}</div>
                                            </code>
                                        </pre>
                                        <div class="mt-3 m-b-25 text-end">
                                            <button class="btn btn-primary btn-clipboard" type="button"
                                                data-clipboard-action="copy"
                                                (click)="copyTextToClipboard(b.respBodyJsonString)"
                                                data-clipboard-target="#clipboardExampleRes"><i class="fa fa-copy"></i>
                                                Copy</button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>

        <footer class="footer-bg" id="contact">
            <div class="container">
                <div class="landing-center ptb50">
                    <div class="title m-b-30"><img class="img-fluid" src="{{layout.getLogo()}}" alt=""
                            width="250px"></div>
                    <div class="footer-content">
                        <p class="mb-4">{{layout.getTenant()}} API merupakan application programming interface (API) yang
                            dikembangkan oleh {{layout.getTenant()}} pada tahun 2022 dan didukung oleh ratusan talenta IT terbaik
                            guna mewujudkan integrasi perbankan yang aman dan mudah,ingin tahu
                            lebih banyah hubungi kami.</p>
                        <a class="btn mrl5 btn-lg btn-primary default-view" (click)="openLg(contactme)"> <i
                                data-feather="message-circle"> </i> Kontak Kami</a>
                        <a class="btn mrl5 btn-lg btn-secondary btn-md-res" (click)="openLg(register)"> <i
                                data-feather="user">
                            </i> Daftar Sekarang!</a>
                    </div>
                </div>
            </div>
            <div class="section-space cuba-demo-section bg-Widget ptb50 bg-primary">
                <div class="container ">
                    <div class="row">
                        <div class="col-md-6 footer-first">
                            <div data-block-plugin-id="block_content:4aa4ecd7-0b53-4f6a-953e-6b376c113a66"
                                class="block block--basic block--footer-third-2">
                                <div class="field field--hidden basic__body"><img class="logo-bri"
                                        src="{{layout.getLogo()}}" width="200px"></div>
                            </div>
                        </div>
                        <div class="col-md-5 footer-bottom" align="left">
                            <div class="field field--hidden basic__body">
                                <div class="address-footer" style="display:flex;">
                                    <p style="color: #FFFFFF; font-size: 12px;"><span style="font-size:14px"><b>{{layout.getTenant()}}</b><br> {{layout.getAddress()}}<br> {{layout.getPhone()}}<br>{{layout.getFax()}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>

        <!-- Modal Login -->
        <ng-template #login let-modal>
            <div class="modal-header ">
                <h4 class="modal-title " id="modal-basic-title ">Masuk Aplikasi</h4>
                <button type="button " class="close " aria-label="Close " (click)="modal.dismiss( 'Cross click') ">
                <span aria-hidden="true ">&times;</span>
              </button>
            </div>
            <form class="theme-form" [formGroup]="loginForm" autocomplete="off">
                <div class="modal-body">
                    <div class="form-group">
                        <label class="col-form-label">Email</label>
                        <input class="form-control" type="email" placeholder="Test@gmail.com" formControlName="email" autocomplete="new-email"
                        [ngClass]="{ 'is-invalid': l.email.invalid , 'is-valid': l.email.valid && l.email.touched}">
                        <span *ngIf="l.email.invalid && l.email.errors && (l.email.dirty || l.email.touched)">
                            <small class="text-danger" *ngIf="l.email.hasError('pattern')">Hanya huruf, angka, dan karakter khusus !@#$%^&*()_+-= yang diperbolehkan.</small>
                        </span>
                    </div>
                    <div class="form-group">
                        <label class="col-form-label">Kata Sandi</label>
                        <div class="form-input position-relative">
                            <input class="form-control" [type]="show ? 'text' : 'password'" name="login[password]" placeholder="*********" formControlName="password"
                            autocomplete="new-password" [ngClass]="{ 'is-invalid': l.password.invalid , 'is-valid': l.password.valid && l.password.touched}">
                            <span *ngIf="l.password.invalid && l.password.errors && (l.password.dirty || l.password.touched)">
                                <small class="text-danger" *ngIf="l.password.hasError('pattern')">Hanya huruf, angka, dan karakter khusus !@#$%^&*()_+-= yang diperbolehkan.</small>
                            </span>
                            <br/><label class="link_word"><a align="left" (click)="open(forgetpassword)" >Lupa Kata Sandi?</a></label>
                            <div class="show-hide" style="top:18px;" (click)="showPassword()" *ngIf="!show"><span class="show"></span></div>
                            <div class="show-hide" style="top:18px;" (click)="showPassword()" *ngIf="show"><span class="Hide"></span></div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-form-label">Enter Captcha</label><br>
                        <img [src]="imageBase64" style="width:50%; height: 50%;" *ngIf="imageBase64" />
                    </div>
                    <div class="form-group">
                        <input class="form-control" type="text" placeholder="captcha" formControlName="captcha"
                        [ngClass]="{ 'is-invalid': l.captcha.invalid , 'is-valid': l.captcha.valid && l.captcha.touched}">
                        <span *ngIf="l.captcha.invalid && l.captcha.errors && (l.captcha.dirty || l.captcha.touched)">
                            <small class="text-danger" *ngIf="l.captcha.hasError('pattern')">Hanya huruf, angka, dan karakter khusus !@#$%^&*()_+-= yang diperbolehkan.</small>
                        </span><br>
                        <button class="btn btn-primary" type="button" style="cursor: pointer" (click)="reloadCaptcha()"  title="Reload Captcha">
                        <i class="fa fa-refresh"></i></button>
                    </div>
                </div>
                <div class="row mt-2 mb-4">
                    <div class="col-md-9 col-9">
                        <label class="container col-form-label">Belum punya akun? <a href="javascript:void(0)" (click)="openLg(register)">Registrasi di sini</a></label>
                    </div>
                    <div class="col-md-2 col-2">
                        <div align="right" style="margin-left:-50px;">
                            <button class="btn btn-primary btn-block" type="submit" [disabled]="loginForm.invalid || disable" (click)="signIn()">Masuk</button>
                        </div>
                    </div>
                </div>
            </form>
        </ng-template>
        <!-- Modal Login -->

        <!-- Modal Contact -->
        <ng-template #contactme let-modal>
            <div class="modal-header ">
                <h4 class="modal-title " id="modal-basic-title ">Silahkan Tanya Kami Disini</h4>
                <button type="button " class="close " aria-label="Close " (click)="modal.dismiss( 'Cross click') ">
                    <span aria-hidden="true ">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <label class="col-form-label">Nama</label>
                    <input class="form-control" type="text" required="" placeholder="Nama">
                </div>
                <div class="form-group">
                    <label class="col-form-label">Kontak</label>
                    <input class="form-control" type="number" required="" placeholder="Contact No">
                </div>
                <div class="form-group">
                    <label class="col-form-label">Email</label>
                    <input class="form-control" type="email" required="" placeholder="Test@gmail.com">
                </div>
                <div class="form-group">
                    <label class="col-form-label">Pesan</label>
                    <textarea class="form-control" id="bm-desc" required="" autocomplete="off"></textarea>
                </div>

            </div>
            <div class="row mt-2 mb-4">
                <div class="col-md-2 col-2">
                    <div align="right" style="margin-left:-20px;">
                        <a href="dashboard/default" class="btn btn-primary" type="button">Kirim</a>
                    </div>
                </div>
            </div>
        </ng-template>
        <!-- Modal Contact -->

        <!-- Modal Register -->
        <ng-template #register let-modal>
            <div class="modal-header ">
                <h4 class="modal-title " id="modal-basic-title ">Daftar ke Website Developer API </h4>
                <button type="button " class="close " aria-label="Close " (click)="modal.dismiss( 'Cross click') ">
                    <span aria-hidden="true ">&times;</span>
                </button>
            </div>
            <div class="modal-body">

                <div class="form-group">
                    <label class="col-form-label">Nama Lengkap</label>
                    <input class="form-control" type="text" required="" placeholder="Masukkan Namamu Disini">
                </div>
                <div class="form-group">
                    <label class="col-form-label">Email</label>
                    <input class="form-control" type="email" required="" placeholder="Masukkan Emailmu Disini">
                </div>
                <div class="form-group">
                    <label class="col-form-label">Kontak</label>
                    <input class="form-control" type="number" required=""
                        placeholder="Masukkan Nomor Handphonemu Disini">
                </div>
                <div class="form-group">
                    <label class="col-form-label">Nama Perusahaan</label>
                    <input class="form-control" type="text" required="" placeholder="Masukkan Nama Perusahaan Disini">
                </div>

                <div class="form-group">
                    <label class="col-form-label">Kata Sandi</label>
                    <div class="form-input position-relative">
                        <input class="form-control" [type]="show ? 'text' : 'password'" name="login[password]"
                            required="" placeholder="*********">
                        <div class="show-hide" style="top:18px;" (click)="showPassword()" *ngIf="!show"><span
                                class="show"></span></div>
                        <div class="show-hide" style="top:18px;" (click)="showPassword()" *ngIf="show"><span
                                class="Hide"></span></div>

                        <div class="form-group">
                            <label class="col-form-label">Ulangi Kata Sandi</label>
                            <div class="form-input position-relative">
                                <input class="form-control" type="password" name="login[password]" required=""
                                    placeholder="*********">
                                <div class="show-hide" style="top:18px;"><span class="show"></span>
                                </div>

                            </div>
                        </div>

                    </div>
                    <div class="row mt-2 mb-4">
                        <div class="col-md-12 col-12">
                            <div align="right" style="margin-left:-20px;">
                                <button class="btn btn-primary" type="button"
                                    (click)="modal.close( 'Save click') ">Register</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </ng-template>
        <!-- Modal Register -->

    </div>